export enum BankCode {
  VNPAY = "VNPAYQR",
  ATM = "VNBANK",
  MOMO = "MOMO",
  CASH = "CASH",
  VITAPAY = "VITAPAY",
  BANK_TRANSFER = "TRANSFER",
}

export enum EPromotionUnit {
  percentage = "%",
  VND = "VND",
}

export enum EOrderType {
  APPT = "APPT",
  PACKAGE = "PACKAGE",
}

export enum EStatusCode {
  Success = 200,
  Created = 201,
  InternalServer = 500,
}

export enum EAppointmentStatus {
  PENDING = "PENDING",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
  CANCELLED = "CANCELLED",
}

export enum EAppointmentType {
  ONLINE = "ONLINE",
  OFFLINE = "OFFLINE",
}

export enum EReAppointmentStatus {
  INCOMING = "INCOMING",
  EXPIRED = "EXPIRED",
}

export enum ESpecialPackageStatus {
  UNPAID = "UNPAID",
  /** Bought but not started - attachments may still be added, same as IN_PROGRESS. */
  NEW = "NEW",
  PENDING = "PENDING",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
  CANCELLED = "CANCELLED",
}

export enum ETagSpecialPackageDetailType {
  ONLINE_SERVICE = "ONLINE_SERVICE",
  OFFLINE_SERVICE = "OFFLINE_SERVICE",
  HOMECARE_SERVICE = "HOMECARE_SERVICE",
  HOMECARE_OR_OFFLINE_SERVICE = "HOMECARE_OR_OFFLINE_SERVICE",
}

export enum EOrderStatus {
  UNPAID = "UNPAID",
  PAID = "PAID",
  REFUND = "REFUND",
  CANCELLED = "CANCELLED",
}

export enum EPaymentMethod {
  CASH = "CASH",
  TRANSFER = "TRANSFER",
  GATEWAY = "GATEWAY",
}

export enum ETypeServicePackage {
  OFFLINE_SERVICE = "OFFLINE_SERVICE",
  ONLINE_SERVICE = "ONLINE_SERVICE",
  HOMECARE_SERVICE = "HOMECARE_SERVICE",
  /** The patient may take it either at home or at a partner clinic - the channel decides. */
  HOMECARE_OR_OFFLINE_SERVICE = "HOMECARE_OR_OFFLINE_SERVICE",
  EVOUCHER = "EVOUCHER",
}

export enum EDrugOrderStatus {
  PENDING = "PENDING",
  COMPLETED = "COMPLETED",
  CANCELLED = "CANCELLED",
}

export enum ECurrency {
  VND = " VNĐ",
}

export enum EUserType {
  PATIENT = "PATIENT",
}

export enum ECollaborationType {
  SITE = "SITE",
  PERSONAL = "PERSONAL",
}

export enum EInComingCallStatus {
  RECEIVED = "RECEIVED",
  REJECTED = "REJECTED",
}

export enum ESeller {
  INSURANCE = "INSURANCE",
}

/** How a package service reaches the patient - what the appointment tag names instead of ONLINE/OFFLINE. */
export enum EServiceChannel {
  HOME = "HOME",
  FACILITY = "FACILITY",
  ONLINE = "ONLINE",
  HOME_OR_FACILITY = "HOME_OR_FACILITY",
}

/** Error codes from the ABIC policy-activation endpoints; always UPPER_SNAKE, never shown raw. */
export enum EPolicyActivationError {
  POLICY_NOT_FOUND = "POLICY_NOT_FOUND",
  POLICY_AMBIGUOUS = "POLICY_AMBIGUOUS",
  CAPTCHA_REQUIRED = "CAPTCHA_REQUIRED",
  TOO_MANY_REQUESTS = "TOO_MANY_REQUESTS",
  CLAIM_TOKEN_INVALID = "CLAIM_TOKEN_INVALID",
  PHONE_REQUIRED = "PHONE_REQUIRED",
  OTP_SEND_FAILED = "OTP_SEND_FAILED",
  OTP_REQUIRED = "OTP_REQUIRED",
  OTP_INVALID = "OTP_INVALID",
  POLICY_ALREADY_CLAIMED = "POLICY_ALREADY_CLAIMED",
}
